import axios from 'axios';
import { ElMessage,ElLoading } from 'element-plus';
import {checkRequestApiList, getUUID} from "@/utils/publicMethonds.js";
import router from "@/router/index.js";
import {useInfoStore} from "@/store/index.js";
// 创建一个 axios 实例
const http = axios.create({
    baseURL: process.env.VITE_API_URL,
    timeout: 60000, // 请求超时时间
});

const request = (option) => {
    const { url, method, params, data, headers, responseType,loading,isFile,noTip,allData } = option
    let load = !option.hasOwnProperty('loading')
    const token = localStorage.getItem("jwt")
    const newHeaders = {
        'Content-Type': 'application/json',
        'Authorization': token || '',
        'Agent-id': process.env.VITE_AGENT_ID || sessionStorage.getItem('domain'),
        // 'Agent-id':6,
        ...headers
    }
    if (checkRequestApiList.some(i=> url.includes(i))){
        Object.assign(newHeaders,getUUID())
    }
    return new Promise((resolve, reject) => {
        const loading = load? ElLoading.service({
            lock: true,
            text: 'Loading',
            background: 'rgba(255,255,255,0.5)',
        }): null
        http.request({
            url: url,
            method,
            params,
            data,
            responseType: responseType || '',
            headers: newHeaders
        }).then((response) => {
            if (isFile && response.status === 200){
                resolve(response)
                return
            }
            const { code, data, message} = response.data;
            if (code === 200) {
                if (allData){
                    resolve(response.data)
                    return;
                }
                resolve(data)
            }else if(code === 403){
                ElMessage.error(message || '请求失败');
                reject(code)
            }else if (code === 400){
                reject(code)
                ElMessage.error(message || '请求失败');
            }else if (code === 401){
                reject(code)
                localStorage.removeItem('jwt')
                const userInfo = useInfoStore()
                userInfo.setKey('baseInfo',{})
                userInfo.setKey('backUrl','')
                userInfo.setKey('backType',0)
                router.push({
                    path: '/login',
                })
                ElMessage.error('登陆过期');
            } else {
                if (code!=405 && !noTip){
                    ElMessage.error(message || '请求失败');
                }
                reject(response.data)
            }
        }).catch(err=>{
            reject(err)
            if (!noTip){
                ElMessage.error(err || '请求失败');
            }
        }).finally(()=>{
            if (loading) loading.close();
        })
    })
}

export default {
    get: (option) => {
        return request({ method: 'get', ...option })
    },
    post: (option) => {
        if (!option.data) {
            option.data = {}
        }
        return request({ method: 'post', ...option })
    },
    delete: (option) => {
        return request({ method: 'delete', ...option })
    },
    put: (option) => {
        return request({ method: 'put', ...option })
    },
}


